<template>
  <!-- 布局壳：bare 页面（登录/关注/协议/日志）走独立裸布局 -->
  <router-view v-if="isBare" />
  <div v-else class="app-layout">
    <AppHeader />
    <main class="page-main">
      <router-view />
    </main>
    <AppFooter />
    <!-- 右下角悬浮小程序入口 -->
    <MiniProgramFloat />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import MiniProgramFloat from '@/components/MiniProgramFloat.vue'

const route = useRoute()
const isBare = computed(() => route.meta.layout === 'bare')
</script>

<style scoped>
/* 全屏 flex 布局：内容不足一屏时 footer 贴底，不产生多余滚动 */
.app-layout {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.page-main {
  flex: 1;
}
</style>
